import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: "30px",
    width: "30px",
    textAlign: "center",
    borderRadius: "50%",
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.text.primary,
    fontWeight: "400 !important",
    fontSize: "15px",
  },
  avatar2: {
    height: "22px",
    width: "22px",
    borderRadius: "50%",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.text.primary,
    fontWeight: "400 !important",
    fontSize: "10px",
    textAlign: "center",
  },
  userImage2: {
    objectFit: "cover",
    height: "22px",
    width: "22px",
    borderRadius: "50%",
  },
  userImage: {
    objectFit: "cover",
    height: "30px",
    width: "30px",
    borderRadius: "50%",
  },
}));

export default useStyles;
